export default {
      id: "ic_fleche-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_fleche-usage",
      toString: function () {
        return this.url;
      }
    }